export const formatArrayToString = (array?: string[]): string | undefined =>
  array?.join(', ');
